<template>
	<div>
		<el-dialog
			:visible.sync="addEditDialog"
			:before-close="handleClose"
			:title="storeObj.type == 'ADD' ? 'Add Category' : 'Edit Category'"
			:fullscreen="false"
			width="550px"
			class="header"
			:close-on-press-escape="false"
			:destroy-on-close="true"
			style="overflow-y: hidden; overflow-x: hidden"
		>
			<div>
				<el-row :gutter="10">
					<el-col :span="4" :offset="1">
						<div>Category</div>
					</el-col>
					<el-col :span="16">
						<el-input
							type="text"
							v-model="category"
							placeholder="Enter Category Name"
							class="input-class"
							v-validate="'required'"
							name="Category Name"
							:maxlength="99"
						/>
						<p>
							<span
								:v-show="errors.has(`Category Name`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Category Name`) }}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 10px; margin-top: 20px" :gutter="10">
					<el-col :span="4" :offset="14">
						<el-button
							class="button-class-white"
							style="border: none; margin-top:40px"
							@click="
							handleClose
							"
							
						>
							Cancel
						</el-button>
					</el-col>
					<el-col style="margin-top: 0px" :span="4" >
						<el-button
							@click="add_edit_category_method()"
							class="button-class"
							style="width: 100px"
						>
							save
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template> 

<script>
import formBuilderServices from "../../../services/formBuilderServices";
export default {
	name: "AddEditCategory",
	props: { addEditDialog: Boolean, storeObj: Object, category_items: Array },
	data: () => ({
		category: "",
	}),
	watch: {
		addEditDialog(val) {
			if (val) {
				this.category = "";
				console.log(this.storeObj);
				if (this.storeObj.type == "EDIT") this.category = this.storeObj.name;
				this.$validator.reset();
			}
		},
	},
	methods: {
		add_edit_category_method() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.storeObj.type == "ADD") {
						let params = {
							name: this.category,
							serial_no: this.category_items.length + 1,
						};
						var self = this;
						formBuilderServices.createCategory(params).then((res) => {
							this.$notify.success({
								title: "Success",
								message: "Category Created Successfully",
								type: "Success",
							});
							self.emit_changes();
						}).catch((err)=>{
							this.$notify.success({
									title: "Success",
									message: err.message,
									type: "Success",
								});
						})
					}
					if (this.storeObj.type == "EDIT") {
						let params = {
							serial_no: this.storeObj.serial_no,
							name: this.category,
						};
						var self = this;
						formBuilderServices
							.editCategory(this.storeObj.id, params)
							.then((res) => {
								this.$notify.success({
									title: "Success",
									message: "Category Edited Successfully",
									type: "Success",
								});
								self.emit_changes();
							});
					}
				} else {
					alert("Enter required fields");
				}
			});
		},
		emit_changes() {
			this.$emit("clicked");
		},
		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style>
.header .el-dialog__header {
	background: white;
	color: black;
	border-bottom: 1px solid grey;
}
.header .el-dialog__title {
	text-transform: capitalize;
	color: black;
}
.el-message-box__header {
	background-color: white;
	border: white;
}
</style>
